module.exports = {
  "id": "6a9444ac-2764-4d7d-aa44-1594b5f1ba95",
  "gtmIds": [
    "GTM-NM5F945"
  ],
  "startTracking": "since_launch",
  "hasInAppVersion": true,
  "group": "gausta",
  "language": "nb-NO",
  "defaultDateFormat": {
    "id": 1,
    "format": "DD/MM/YYYY",
    "name": "Numeric Day First (23/04/2026)"
  },
  "defaultNumberFormat": {
    "id": 3,
    "name": "European (Dot thousands, Comma decimals)",
    "format": "#.###,##"
  },
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "nb-NO",
    "en-US"
  ],
  "website": "https://www.gausta.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}